// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-scheduling-placeholder[data-v-722fb7da] {\n  background-color: #eff3f7;\n  border-radius: 5px;\n  padding: 15px;\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
